<template>
	<dialog-component custom-class="dialog-cookies-wrap">
		<p class="cookies-title">Мы заботимся о ваших Cookie</p>
		<p class="cookies-description">
			Мы используем файлы cookie для обеспечения корректной работы сайта и улучшения качества его работы
		</p>
		<img v-if="!isMtsby" class="cookies-img" src="@/resources/images/cookies.png" alt="cookie" />
		<div class="cookies-wrapper-btn">
			<base-button text="Настройки cookie" variant="secondary" @click="openSettingCookies" />
			<base-button text="Отклонить" variant="secondary" @click="rejectAll" />
			<base-button text="Принять все cookie" @click="acceptAll" />
		</div>
		<p class="cookies-footer">
			Нажимая кнопку, вы соглашаетесь на использование файлов cookie в соответствии с
			<a href="/cookie-policy" rel="noopener noreferrer">Политикой обработки файлов cookie</a>
		</p>
	</dialog-component>
</template>

<script setup lang="ts">
import DialogComponent from '@/components/dialogs/DialogComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import AppConfig from '@/config'
import { useCookiesStore } from '@/stores/cookies'

const cookiesStore = useCookiesStore()
const isMtsby = AppConfig.isMts

function openSettingCookies() {
	cookiesStore.openCookiesSettings()
}

function rejectAll() {
	cookiesStore.disableAnalyticsCookies()
	cookiesStore.setCookiesDialogShown()
	cookiesStore.saveCookiesSettings()
	cookiesStore.hideCookiesDialog()
}

function acceptAll() {
	cookiesStore.enableAnalyticsCookies()
	cookiesStore.setCookiesDialogShown()
	cookiesStore.saveCookiesSettings()
	cookiesStore.hideCookiesDialog()
}
</script>

<style lang="scss" scoped>
.cookies {
	text-align: center;
	&-title {
		font: var(--font-heading);
		margin-bottom: 8px;
		text-align: center;
		@media (max-height: $small-height) {
			margin-bottom: 8px;
			font: var(--font-label);
		}
		@if $is-mts {
			color: var(--text-primary);
			font-feature-settings:
				'liga' off,
				'clig' off;
		}
	}
	&-description {
		font: var(--font-body-small);
		margin-bottom: 24px;
		text-align: center;
		color: var(--text-secondary);
		@media (max-height: $small-height) {
			margin-bottom: 12px;
			font: var(--font-caption);
		}
	}
	&-wrapper-btn {
		width: 100%;
		& > * {
			margin-bottom: 12px;
			@media (max-height: $small-height) {
				margin-bottom: 8px;
				max-height: 40px;
				font: var(--font-label);
			}
		}
		@if $is-mts {
			:deep(.btn:not(.btn-secondary)) {
				background: var(--background-inverse);
			}
			:deep(.btn-secondary) {
				color: var(--text-primary);
			}
		}
	}
	&-img {
		margin-bottom: 24px;
		width: 100px;
		@media (max-height: $small-height) {
			width: 60px;
		}
	}
	&-footer {
		font: var(--font-body-small);
		text-align: center;
		color: var(--text-secondary);
		@media (max-height: $small-height) {
			font: var(--font-caption);
		}
		@if $is-mts {
			font: var(--font-body-small);
			color: var(--text-secondary);
		}
		& a {
			text-decoration: underline;
			font: var(--font-body-small);
			color: var(--text-secondary);
			transition: $transition-color;
			@media (max-height: $small-height) {
				font: var(--font-caption);
			}
			@if $is-mts {
				font: var(--font-body-small);
				color: var(--text-secondary);
				text-decoration-line: underline;
				text-decoration-style: solid;
				text-decoration-skip-ink: none;
				text-decoration-thickness: auto;
				text-underline-offset: auto;
				text-underline-position: from-font;
			}
			&:hover {
				color: var(--text-secondary-hover);
				text-decoration: none;
			}
			&:active {
				color: var(--text-secondary-hover);
				text-decoration: none;
			}
		}
	}
}
</style>
